Object.defineProperty(exports, "__esModule", {
    value: true
});
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
//#region src/utils/context.ts
function remoteToEntry(r) {
    return {
        name: r.name,
        alias: r.alias,
        entry: "entry" in r ? r.entry : void 0,
        version: "version" in r ? r.version : void 0,
        type: r.type,
        entryGlobalName: r.entryGlobalName,
        shareScope: r.shareScope
    };
}
/**
* Build a partial MFContext from runtime Options.
* Used to enrich diagnostic entries with host context at error sites.
*/ function optionsToMFContext(options) {
    var _options_remotes, _options_remotes1;
    var shared = {};
    for (var ref of Object.entries(options.shared)){
        var _ref = _sliced_to_array._(ref, 2), pkgName = _ref[0], versions = _ref[1];
        var _first_shareConfig, _first_shareConfig1, _first_shareConfig2, _first_shareConfig3;
        var first = versions[0];
        if (first) shared[pkgName] = {
            version: first.version,
            singleton: (_first_shareConfig = first.shareConfig) === null || _first_shareConfig === void 0 ? void 0 : _first_shareConfig.singleton,
            requiredVersion: ((_first_shareConfig1 = first.shareConfig) === null || _first_shareConfig1 === void 0 ? void 0 : _first_shareConfig1.requiredVersion) === false ? false : (_first_shareConfig2 = first.shareConfig) === null || _first_shareConfig2 === void 0 ? void 0 : _first_shareConfig2.requiredVersion,
            eager: first.eager,
            strictVersion: (_first_shareConfig3 = first.shareConfig) === null || _first_shareConfig3 === void 0 ? void 0 : _first_shareConfig3.strictVersion
        };
    }
    return {
        project: {
            name: options.name,
            mfRole: ((_options_remotes = options.remotes) === null || _options_remotes === void 0 ? void 0 : _options_remotes.length) > 0 ? "host" : "unknown"
        },
        mfConfig: {
            name: options.name,
            remotes: ((_options_remotes1 = options.remotes) === null || _options_remotes1 === void 0 ? void 0 : _options_remotes1.map(remoteToEntry)) ?? [],
            shared
        }
    };
}
//#endregion
exports.optionsToMFContext = optionsToMFContext; //# sourceMappingURL=context.cjs.map
